import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export const EmissionSaving = ({
  totalEmission,
  benchmarkEmission,
  title,
  subtitle,
}: {
  totalEmission: number;
  benchmarkEmission: number;
  title: string;
  subtitle?: string;
}) => {
  let percentage = (1 - totalEmission / benchmarkEmission) * 100;
  if (isNaN(percentage)) {
    percentage = 0;
  }

  console.log(totalEmission, benchmarkEmission, percentage);

  return (
    <Card className="h-full">
      <CardHeader className="pb-2">
        <CardTitle className="flex justify-between items-center">{title}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col justify-center items-center h-full">
        <p className="text-4xl font-bold text-green-500">{percentage.toFixed(2)}%</p>
        {subtitle && <p className="text-sm text-muted-foreground mt-2 text-center">{subtitle}</p>}
      </CardContent>
    </Card>
  );
};
